import * as React from 'react'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import Button from '@mui/material/Button'
import {Divider, Grid, Tooltip} from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import UIMaterialTable from './UIMaterialTable'
import { useState } from 'react'
import { MaterialInfo, appdata } from '../internalModules'
import {Material} from '../internalModules'
import UIMaterialDialog from './UIMaterialDialog'
import { drawerButtonStyle, drawerWidth } from '../Graphics'

type Props = {
  toggleMaterialsOpen: Function
  isOpen: boolean
  updateApp: Function
}

export default function UIMaterialDrawer({toggleMaterialsOpen, isOpen, updateApp}: Props) {

  const [dialogOpen, setDialogOpen] = useState(false)

  const toggleDialogOpen = (open: boolean) => (event: React.MouseEvent) => {
    setDialogOpen(open)
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
  }

  const handleAcceptDialog = (info: MaterialInfo) => {
    let gwpByArea = 0
    let gwpByVolume = 0
    let gwpByWeight = 0
    switch (info.units) {
      case 'm2':
        gwpByArea = info.gwp
        break;
      case 'm3':
        gwpByVolume = info.gwp
        break;
      case 'kg':
        gwpByWeight = info.gwp
        break;
      default:
        break;
    }
    //create new material with the material info
    const newMaterial = new Material(info.category, info.name, 'Custom', gwpByArea, gwpByVolume, gwpByWeight, info.density, info.transparent, info.notes)
    appdata.createMaterial(newMaterial)
    setDialogOpen(false)
    updateApp()
  }

  return (
    <div>
      <Drawer
        anchor="right"
        variant="temporary"
        open={isOpen}
        onClose={toggleMaterialsOpen(false)}
      >
        <Box sx={{ width: drawerWidth, height: '100%'}} >
          <Button
            sx={{height: 64}}
            variant={'outlined'}
            size='large'
            endIcon={<ChevronRightIcon />}
            onClick={toggleMaterialsOpen(false)}
            fullWidth
          >
            Close
          </Button>
          <Divider />
          <Grid container justifyContent='center' direction={'row'} >
            <Grid item>
              <Tooltip arrow title='define a new material'>
                <Button variant={'contained'} sx={{margin:1, px:6}} onClick={toggleDialogOpen(true)}>Create a New Material</Button>
              </Tooltip>  
            </Grid>
            <Grid item>
              <Tooltip arrow title='download additional materials to import into your project'>
                <Button variant={'outlined'} sx={{margin:1, px:6}}
                  onClick={()=>{window.open("https://wrns.sharepoint.com/:f:/s/WRNSFeather/EqdPnuNBrGFMoB6RZuWXxngBaC3ZibkbmZKKNAt88dxfnw?e=1Sig5h", "_blank")}}>
                    Get more materials</Button>
              </Tooltip>
            </Grid>
          </Grid>
          <UIMaterialTable updateApp={updateApp}/>
          <UIMaterialDialog key='0' materialGuid='' isOpen={dialogOpen} closeDialog={handleCloseDialog} acceptDialog={handleAcceptDialog}/>
        </Box>
      </Drawer>
    </div>
  )
}
